export default __webpack_public_path__ + "static/media/drop.8ee900e0.png";